module.exports = __webpack_public_path__ + "static/media/amusement(10).58ff8283.PNG";